import { RouteObject } from "react-router-dom";
import { Landing } from "./components/landing/landing";

export interface SystemTypesRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: SystemTypesRoute[];
}

export const systemTypesRoutes: SystemTypesRoute[] = [
  {
    path: "/ax/settings/system-types",
    element: <Landing />,
  },
];